import React from 'react';
import './input.styles.scss';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ValidationOptions } from 'react-hook-form/dist/types';
import { validateRequired } from 'utils/form';
import { CustomInput, CustomInputProps } from './CustomInput';

export interface InputFieldProps extends CustomInputProps {
	validation?: ValidationOptions;
}

export const InputField: React.FC<InputFieldProps> = ({
	validation = {},
	onlyNumbers,
	onChange,
	name = '',
	required,
	onClickEndButton,
	...props
}) => {
	const { t } = useTranslation('errors');
	const { register, errors, setValue, getValues, watch } = useFormContext();

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (onlyNumbers) {
			setValue(name, e.target.value.replace(/\D/, ''));
		}
		if (onChange) {
			onChange(e);
		}
	};

	const handleEndButtonClick = () => {
		const currentValue = getValues()[name];
		if (onClickEndButton && currentValue) {
			onClickEndButton(currentValue);
		}
	};

	return (
		<CustomInput
			name={name}
			onClickEndButton={handleEndButtonClick}
			onChange={handleChange}
			ref={register({
				...validateRequired(required, t('required')),
				...validation,
			})}
			error={errors?.[name]?.message}
			inputValue={watch(name)}
			{...props}
		/>
	);
};
